/**
 * Utility for triggering file downloads.
 * Replaces the duplicated pattern of creating an anchor element,
 * setting href/download, clicking, and removing.
 */

/**
 * Trigger a file download from a URL.
 * Creates a temporary anchor element, clicks it, and cleans up.
 *
 * @param url - The URL to download from (can be a remote URL or blob URL)
 * @param filename - The suggested filename for the download
 */
export function triggerDownload(url: string, filename: string): void {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
